export const configConstants = {
  CONFIG_REQUEST: "GET_CONFIG_REQUEST",
  CONFIG_SUCCESS: "GET_CONFIG_SUCCESS",
  CONFIG_FAILURE: "GET_CONFIG_FAILURE",
  CONFIG_MAINTANANCE_FAILURE: "CONFIG_MAINTANANCE_FAILURE"
};
